"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadImg = exports.copyToClipboard = void 0;
const dom_to_image_1 = __importDefault(require("dom-to-image"));
const copyToClipboard = async ({ dom }) => {
    let isSuccess = true;
    dom_to_image_1.default
        .toBlob(dom, dtiProps(dom))
        .then(async (blob) => {
        await navigator.clipboard.write([
            new ClipboardItem({
                [blob.type]: blob
            })
        ]);
    })
        .catch(() => {
        isSuccess = false;
    });
    return {
        isSuccess
    };
};
exports.copyToClipboard = copyToClipboard;
const downloadImg = async ({ dom, title, type }) => {
    let isSuccess = true;
    dom_to_image_1.default?.[type === 'jpeg' ? 'toJpeg' : 'toPng'](dom, dtiProps(dom))
        .then(dataUrl => {
        const link = document.createElement('a');
        link.download = `${title}.${type}`;
        link.href = dataUrl;
        link.click();
    })
        .catch(() => {
        isSuccess = false;
    });
    return {
        isSuccess
    };
};
exports.downloadImg = downloadImg;
const dtiProps = (dom) => {
    return {
        height: (dom.offsetHeight * 8000) / dom.offsetWidth,
        width: (dom.offsetWidth * 8000) / dom.offsetWidth,
        style: {
            transform: 'scale(' + 8000 / dom.offsetWidth + ')',
            transformOrigin: 'top left',
            width: dom.offsetWidth + 'px',
            height: dom.offsetHeight + 'px'
        }
    };
};
